"use client";

import "../styles/main.css";
import "../styles/hover.css";
import "animate.css";
import { Container, Row, Col } from "react-bootstrap";
import { motion, Variants, useInView } from "framer-motion";
import { useRef } from "react";

const HeroComponent = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.5, once: false });

  return (
    <section id="hero-section">
      <div className="animate__animated animate__fadeIn text-center hero-section-elements">
        {/* <h1 className="main-page-title hvr-wobble-vertical">I'm Khariza</h1>
        <br /> */}
        <h2 className="page-not-found-title hvr-wobble-vertical">
          Web Developer <span className="white-text">&</span> Designer
        </h2>
      </div>
    </section>
  );
};

export default HeroComponent;
